import { useEffect, useState } from 'react';
import { mobileApiClient } from '@/services/mobileApiClient';

/**
 * Carga el logo del tenant activo de forma autenticada.
 *
 * El endpoint GET .../logo sirve el PNG con la sesion en cookies; un
 * <img src> directo no envia credenciales, asi que se pide como blob con
 * mobileApiClient (withCredentials) y se expone como object URL.
 * Null cuando no hay tenant, no hay URL o el servidor responde 404.
 */
export function useTenantLogo(tenantId: string | null, logoUrl: string | null) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!tenantId || !logoUrl) {
      setObjectUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
      return;
    }

    let cancelled = false;
    let currentUrl: string | null = null;

    mobileApiClient
      .get(logoUrl, { responseType: 'blob' })
      .then((res) => {
        if (cancelled) return;
        const blob = res.data as Blob;
        if (!(blob instanceof Blob) || !blob.type.startsWith('image/')) {
          setObjectUrl((prev) => {
            if (prev) URL.revokeObjectURL(prev);
            return null;
          });
          return;
        }
        currentUrl = URL.createObjectURL(blob);
        setObjectUrl((prev) => {
          if (prev) URL.revokeObjectURL(prev);
          return currentUrl;
        });
      })
      .catch(() => {
        if (!cancelled) {
          setObjectUrl((prev) => {
            if (prev) URL.revokeObjectURL(prev);
            return null;
          });
        }
      });

    return () => {
      cancelled = true;
      if (currentUrl) {
        try {
          URL.revokeObjectURL(currentUrl);
        } catch {
          // ignorar si ya fue revocado
        }
      }
    };
  }, [tenantId, logoUrl]);

  return { objectUrl };
}
